<template>
  <v-dialog v-model="dialog" max-width="280">
    <v-card class="primary">
      <div
        class="primary white--text pt-2 px-2 d-flex align-center font-hemi-head"
      >
        <span style="font-size: 16px">PIANIFICA CREDITI SLOT</span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <!-- value -->
      <div
        class="primary--text text--darken-3 text-center text-h4 font-weight-black mt-2"
        style="height: 35px"
      >
        <span v-if="value && parseFloat(value) != 0">{{
          parseFloat(value)
        }}</span>
        <span v-else-if="valueInitial && parseFloat(valueInitial) != 0">{{
          parseFloat(valueInitial)
        }}</span>
        <span v-else>-</span>
      </div>

      <v-container>
        <v-row no-gutters class="text-center">
          <!-- tastierino 1-9 -->
          <v-col cols="4" v-for="i in 9" :key="i">
            <v-btn depressed class="primary white--text" @click="insert(i)">{{
              i
            }}</v-btn>
          </v-col>

          <!-- canc 0 back -->
          <v-col cols="4">
            <v-btn text class="white--text" @click="clear()">CANC</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              large
              depressed
              class="primary white--text"
              @click="insert(0)"
              >0</v-btn
            >
          </v-col>
          <v-col cols="4">
            <v-btn text class="white--text" @click="backspace()">
              <v-icon>backspace</v-icon>
            </v-btn>
          </v-col>

          <!-- invia -->
          <v-col cols="12" class="mt-2">
            <v-btn
              v-if="isMassimo"
              block
              text

              class="mb-2 white--text"
              :loading="processing"
              @click="salva(0)"
            >
              Azzera
            </v-btn>
            <v-btn
              large
              block
              color="secondary"
              :loading="processing"
              :disabled="!parseFloat(value) || error"
              @click="salva()"
            >
              Salva
            </v-btn></v-col
          >
        </v-row>
      </v-container>
      <div v-if="error" class="px-2 error white--text text-center">
        {{ error }}
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import db from "../../js/db";

export default {
  mixins: [mixins],
  components: {},
  mounted() {
    console.log("--> AstaPlanNumpad mounted.");
    db.on("AstaPlanNumpad", this.show);
  },
  destroyed() {
    console.log("<-- AstaPlanNumpad destroyed.");
    db.off("AstaPlanNumpad", this.show);
  },
  data() {
    return {
      valueInitial: "",
      value: "",
      ruolo_abc: null,
      i: null,
      dialog: false,
      error: "",
      processing: false,
    };
  },
  methods: {
    // handleVisibility(val) {
    //   if (val) {
    //     this.show();
    //   } else {
    //     this.dismiss();
    //   }
    // },
    show(value, ruolo_abc, i) {
      this.dialog = true;
      this.valueInitial = value.toString();
      this.value = "";
      this.error = "";
      this.ruolo_abc = ruolo_abc;
      this.i = i;
    },
    dismiss() {
      this.dialog = false;
    },
    keyup(e) {
      switch (e.keyCode) {
        case 13:
          this.salva();
          break;
        case 8:
          this.backspace();
          break;
        case 46:
          this.clear();
          break;
        case 48:
        case 96:
          this.insert(0);
          break;
        case 49:
        case 97:
          this.insert(1);
          break;
        case 50:
        case 98:
          this.insert(2);
          break;
        case 51:
        case 99:
          this.insert(3);
          break;
        case 52:
        case 100:
          this.insert(4);
          break;
        case 53:
        case 101:
          this.insert(5);
          break;
        case 54:
        case 102:
          this.insert(6);
          break;
        case 55:
        case 103:
          this.insert(7);
          break;
        case 56:
        case 104:
          this.insert(8);
          break;
        case 57:
        case 105:
          this.insert(9);
          break;
        default:
          break;
      }
    },
    insert(i) {
      this.value = this.value.concat(i);
      this.error = false;
    },
    clear() {
      this.value = "";
    },
    backspace() {
      this.value = this.value.slice(0, -1);
    },
    salva(valoreForzato) {
      const slot = (this.$store.getters.myPlan[this.ruolo_abc] || {})[this.i];
      if (!slot || slot.associato) {
        this.error = "Questo slot non è più disponibile per pianificare crediti.";
        return;
      }
      if (this.processing) {
        return;
      }
      this.processing = true;

      const parsedValue = valoreForzato === 0 ? 0 : parseFloat(this.value);

      if (parsedValue > this.myMaxOfferta) {
        this.error = "Valore non valido (max " + this.myMaxOfferta + ")";
        this.processing = false;
        this.clear();
        return;
      }

      // db.setPlanCrediti(this.ruolo_abc, this.i, parsedValue)
      return db.updatePlan({
        [this.ruolo_abc]: {
          [this.i]: {
            crediti: parsedValue,
          },
        },
      })
        .then(() => {
          this.dismiss();
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
  computed: {
    isMassimo() {
      return this.asta_info && this.asta_info.lega &&
        this.asta_info.lega.nRuoli.op === "<=";
    },
    myMaxOfferta() {
      return this.my_squadra.max_offerta;
    },
  },
  watch: {
    dialog: function (val) {
      if (val) {
        window.addEventListener("keyup", this.keyup);
      } else {
        window.removeEventListener("keyup", this.keyup);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
